import LoggerAwareViewModel from './LoggerAwareViewModel';

const ReactLifecyclePresenter = LoggerAwareViewModel.named('ReactLifecyclePresenter').actions((self) => ({
    viewDidMount() {
        // self.logger.log('viewDidMount', self.toString());
    },
    viewWillUnmount() {
        // self.logger.log('viewWillUnmount', self.toString());
    },
}));

export default ReactLifecyclePresenter;
